import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { SubmitApplicationStepComponent } from "../../wizard/wizard-steps/submit-application-step/submit-application-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class SubmitApplicationStep extends WizardStepBase {
  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = SubmitApplicationStepComponent;
  }
}
